import { useEffect, useState } from 'react';

/**
 * Debounce hook: returns `value` but only after it has stopped changing for
 * `delay` ms. Great for search inputs where we want to filter/query only
 * once the user pauses typing.
 */
export default function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
